module.exports = {
      id: "stories-usage",
      viewBox: "0 0 33 27.835",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#stories",
      toString: function () {
        return this.url;
      }
    }